import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CreateNewClientService {

  constructor(private http: HttpClient) { }

  private readonly createClientbaseUrl = 'onboarding-client';


  public getPartners() {
    const url = `${this.createClientbaseUrl}/partners`;
    return this.http.get(url);
  }

  public getServices() {
    return this.http.get(`${this.createClientbaseUrl}/services`);
  }

  public createNewClient(payload) {
    return this.http.post(`${this.createClientbaseUrl}`, payload);

  }

  public createOnbClient() {
    return this.http.post(`${this.createClientbaseUrl}/create-client/demo`,'');

  }
}